<template>
  <div class="tile" :class="{'location--error': listedIssue}">
    <p class="text__bold text__center">Listed Locations</p>
    <p
      v-if="!active.locations || active.locations.length === 0"
      class="flex__center text__center lender--placeholder"
    >{{ active.display_name }} does not appear on any location pages</p>
    <div v-else>
      <p class="text__center m-tb-small">{{ active.display_name }} appears on the following pages</p>
      <simplebar class="lender--overflow" data-simplebar-auto-hide="false">
        <ul class="locations--list-show">
          <li v-for="location in active.locations" :key="location._id" class="lender--list-item">
            <span class="text__dark">&bull;</span>
            <a :href="`https://flatbranchhomeloans.com/locations/${location.url}`" target="_blank">
              {{ location.address.city }} - {{ location.address.state }}
              <br />
              <span class="text__small">({{ location.address.street }})</span>
            </a>
          </li>
        </ul>
      </simplebar>
      <p
        v-if="listedIssue"
        class="text__center location--error-msg"
      >Warning: unlicensed location present</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["active"],
  computed: {
    listedIssue() {
      if (this.active.locations.length === 0) {
        return true;
      }
      let issue = true;
      this.active.locations.forEach(listed => {
        const found = this.active.licensed_locations.findIndex(licensed => {
          return listed._id === licensed._id;
        });
        issue = issue && found >= 0;
      });
      return !issue;
    }
  }
};
</script>

<style scoped lang="scss">
.location--error {
  background-color: $trans-maroon;
  p,
  span {
    color: #000;
  }
}
.location--error-msg {
  font-style: italic;
  margin-top: 15px;
}
@media (min-width: $md) {
  .locations--list-show {
    grid-template-columns: 1fr;
    grid-row-gap: 5px;
  }
}
@media (min-width: $xxl) {
  .locations--list-show {
    grid-template-columns: 1fr 1fr;
  }
}
</style>